// project imports
import { Navigate } from 'react-router';
import Login from 'views/pages/authentication/authentication3/Login';
import Register from 'views/pages/authentication/authentication3/Register';

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    children: [
        {
            path: '/auth/*',
            element: <Login />
        },
        {
            path: '/',
            element: <Navigate to="/auth/login" />
        },
        {
            path: '/auth/register',
            element: <Register />
        },
        {
            path: '*',
            element: <Navigate to="/" />
        }
    ]
};

export default AuthenticationRoutes;
